module.exports = __webpack_public_path__ + "img/penicillin.71d38787.jpg";